export default __webpack_public_path__ + "static/media/Ballroll_00350.acfa7a32.png";